export default {
  breakpoints: {
    desktop: 1041,
    tablet: 769,
  },
  colors: {
    black: '#000000',
    white: '#FFFFFF',
  },
}
